module.exports = __webpack_public_path__ + "img/upload-camera.34f5800f.svg";